import { render, staticRenderFns } from "./SingleAddressViewShelter.vue?vue&type=template&id=0ca12dcc&"
import script from "./SingleAddressViewShelter.vue?vue&type=script&lang=js&"
export * from "./SingleAddressViewShelter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports